import { useCallback } from 'react';
import { useQueryClient, type QueryKey } from '@tanstack/react-query';

// `id && getDetailQueryKey(id)` 형태의 조건부 key 허용 (id가 number/string인 경우 0, '' 포함)
type OptionalQueryKey = QueryKey | false | 0 | '' | null | undefined;

const isQueryKey = (queryKey: OptionalQueryKey): queryKey is QueryKey => Boolean(queryKey);

/**
 * mutation 이후 캐시 갱신용 훅
 * - 전역 refetchOnMount: false 이므로 invalidate(stale 표시)만으로는 다른 화면 캐시가 갱신되지 않음
 * - refetchQueries(기본 type: 'all')로 active/inactive 쿼리를 모두 즉시 refetch
 * - queryKey는 prefix 매칭 (파라미터 없는 목록 key 전달 시 모든 검색/페이지 조합 포함)
 * - falsy 값은 무시하므로 조건부 key를 인라인으로 전달 가능 (ex. `id && getDetailQueryKey(id)`)
 */
export const useRefetchQueries = () => {
	const queryClient = useQueryClient();

	return useCallback(
		(...queryKeys: OptionalQueryKey[]) =>
			Promise.all(queryKeys.filter(isQueryKey).map(queryKey => queryClient.refetchQueries({ queryKey }))),
		[queryClient]
	);
};
